import { IRetirePet, retirePetActions } from "../../../state/retirePet";
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";

export const useRetirePetStore = () => {
  const dispatch = useDispatch();
  const { petName, petId, retireReason, reasonDescription, isPetDeleted } =
  useSelector((state: IRootState) => state.retirePet as IRetirePet);

  const setPetName = (petName: string) => {
    dispatch(retirePetActions.setPetName(petName));
  };

  const setPetId = (petId: string) => {
    dispatch(retirePetActions.setPetId(petId));
  };

  const setRetireReason = (retireReason: string) => {
    dispatch(retirePetActions.setRetireReason(retireReason));
  };
  const setReasonDescription = (reasonDesc: string) => {
    dispatch(retirePetActions.setReasonDescription(reasonDesc));
  };
  const setDeletedStatus = (status: boolean) => {
    dispatch(retirePetActions.setDeletedStatus(status));
  };

  return {
    petName,
    petId,
    retireReason,
    reasonDescription,
    isPetDeleted,
    setPetName,
    setPetId,
    setRetireReason,
    setReasonDescription,
    setDeletedStatus,
  };
};
